// extracted by mini-css-extract-plugin
export default {"tag":"j45XP","extra":"ZGY1h","gradient":"Vd4bu","icon":"LXOu4","cnImage":"fn7Ad"};